import {
  arrayBuilderItemFirstPageTitleUI,
  currentOrPastDateUI,
  fullNameUI,
  selectUI,
  ssnUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateDateRange } from 'platform/shared/health-apps';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['dependent-info--basic-title'];
const INPUT_LABELS = {
  name: content['dependent-info--basic-name-label'],
  relationship: content['dependent-info--basic-relationship-label'],
  ssn: content['dependent-info--basic-ssn-label'],
  dob: content['dependent-info--basic-birthdate-label'],
  became: content['dependent-info--basic-became-label'],
};

const {
  fullName,
  dependentRelation,
  socialSecurityNumber,
  dateOfBirth,
  becameDependent,
} = FULL_SCHEMA.properties.dependents.items.properties;
const SCHEMA_LABELS = Object.fromEntries(
  dependentRelation.enum.map(key => [key, key]),
);

const VALIDATIONS = [
  validateDateRange({
    startDateKey: 'dateOfBirth',
    endDateKey: 'becameDependent',
    allowEqualDates: true,
    rangeErrorMessage: content['validation-error--dependent-date'],
  }),
];

export default {
  uiSchema: {
    ...arrayBuilderItemFirstPageTitleUI({
      title: TITLE_TEXT,
      showEditExplanationText: false,
    }),
    fullName: fullNameUI(title => `${INPUT_LABELS.name} ${title}`),
    dependentRelation: selectUI({
      title: INPUT_LABELS.relationship,
      labels: SCHEMA_LABELS,
    }),
    socialSecurityNumber: ssnUI(INPUT_LABELS.ssn),
    dateOfBirth: currentOrPastDateUI(INPUT_LABELS.dob),
    becameDependent: currentOrPastDateUI(INPUT_LABELS.became),
    'ui:validations': VALIDATIONS,
  },
  schema: {
    type: 'object',
    required: [
      'fullName',
      'dependentRelation',
      'socialSecurityNumber',
      'dateOfBirth',
      'becameDependent',
    ],
    properties: {
      fullName,
      dependentRelation,
      socialSecurityNumber,
      dateOfBirth,
      becameDependent,
    },
  },
};
